(ns portal.os-access-modal.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/inform/lightbulb-coil.svg$default" :as Lightbulb]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.input :refer [input]]
            [portal.os-access-modal.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn purpose->hint [purpose]
  (case purpose
    "demo" "You will get access to a sample (demo) campaign to explore in Creative Optimizations."
    "enable-advertiser" "You already have an advertiser that you want to get activated inside Creative Optimizations."
    "pitch" "You intend on using the Creative Optimizations product as part of an upcoming pitch."
    "What is the purpose of your request?"))

(defui enable-advertiser-content []
  ($ :<>
     ($ form-field
        {:label "Agency"
         :err-msg (form/use-error-message [:agency])
         :required? true}
        ($ input (merge (form/use-bind-control [:agency])
                        {:placeholder "Enter agency name..."})))

     ($ form-field
        {:label "Advertiser"
         :err-msg (form/use-error-message [:advertiser])
         :required? true}
        ($ input (merge (form/use-bind-control [:advertiser])
                        {:placeholder "Enter advertiser name..."})))))

(defui pitch-content []
  (let [{pitch-material :value :as pitch-material-control} (form/use-bind-control [:pitch-material])
        campaign-link-control (form/use-bind-control [:campaign-link])
        campaign-link-error (form/use-error-message [:campaign-link])]
    ($ :<>
       ($ form-field
          {:label "Pitch material"
           :err-msg (form/use-error-message [:pitch-material])
           :required? true}
          (r/as-element
           [dropdown (merge pitch-material-control
                            {:options [{:label "Use a sample (demo) campaign"
                                        :value "sample"}
                                       {:label "Use an existing campaign"
                                        :value "existing"}
                                       {:label "Create a new custom campaign"
                                        :value "custom"}]})]))
       (when (= pitch-material "existing")
         ($ form-field
            {:label "Campaign link"
             :err-msg campaign-link-error
             :required? true}
            ($ input (merge campaign-link-control
                            {:placeholder "Enter Creative Optimizations campaign link..."})))))))

(defmodal request-modal :os/access-request
  []
  (let [{:keys [purpose pitch-material notes]} (use-subscribe [:form.os-access-modal/value []])]
    (uix/use-effect (fn []
                      (rf/dispatch [:form.os-access-modal/init])
                      (fn []
                        (rf/dispatch [:form.os-access-modal/destroy])))
                    [])
    ($ modal-v2
       {:title "Request access"
        :footer ($ Stack
                   {:direction "row"
                    :gap 1
                    :sx #js {:alignSelf "right"}}
                   ($ Button
                      {:variant "text"
                       :sx #js {:color "text.primary"}
                       :on-mouse-down #(rf/dispatch [:modal/close])}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :on-click #(rf/dispatch [:form.os-access-modal/submit])}
                      "Send request"))}
       ($ Stack
          {:gap 2
           :sx #js {:py 2
                    :width 392}}
          ($ form-field
             {:label "Purpose"
              :err-msg (form/use-error-message [:purpose])
              :required? true}
             (r/as-element
              [dropdown (merge (form/use-bind-control [:purpose])
                               {:options [{:label "Access a demo of the product"
                                           :value "demo"}
                                          {:label "Enable an existing advertiser"
                                           :value "enable-advertiser"}
                                          {:label "Product pitch"
                                           :value "pitch"}
                                          {:label "Other"
                                           :value nil}]})])
             ($ hint (purpose->hint purpose)))

          (case purpose
            "enable-advertiser" ($ enable-advertiser-content)
            "pitch" ($ pitch-content)
            nil)

          ($ form-field
             {:label "Additional information"
              :err-msg (form/use-error-message [:notes])
              :required? (nil? purpose)}
             ($ TextField
                (merge (form/use-bind-control [:notes])
                       {:placeholder (str "Add more information to help us understand your request better"
                                          (cond
                                            (= purpose "demo")
                                            ", e.g. who is the audience?"

                                            (and (= purpose "pitch") (= pitch-material "custom"))
                                            ", e.g. do you already have existing assets for this new campaign?"

                                            :else "..."))
                        :fullWidth true
                        :multiline true
                        :minRows 3
                        :slotProps #js {:htmlInput #js {:maxlength 400}}}))
             ($ Stack
                {:direction "row"
                 :alignItems "center"
                 :gap 0.5
                 :sx #js {:alignSelf "flex-end"}}
                ($ Typography
                   {:color "text.secondary"
                    :fontSize "sm"}
                   "Characters:")
                ($ Typography
                   {:fontWeight "600"
                    :fontSize "sm"}
                   (str (count notes) "/400"))))
          ($ Alert
             {:variant "inline"
              :icon ($ Lightbulb)
              :sx #js {:padding "5px 8px"}}
             "Information related to your current workspace will be automatically attached to your request.")))))
